import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postFunnelReportsAppGroupIdCreateCacheKeys } from "./constants";
import type { PostFunnelReportsAppGroupIdCreateProps, GlobalFunnelRun } from "./types";

export const postGlobalFunnelRun = reactQueryMutationAdapter(
  postFunnelReportsAppGroupIdCreateCacheKeys,
  ({ appGroupId, definition }: PostFunnelReportsAppGroupIdCreateProps): Promise<GlobalFunnelRun> =>
    fetch(`/funnel_reports/${appGroupId}/create`, "POST", definition, undefined, {
      propagateFetchRequestError: false,
    })
);
